import { ActionType, getType, StateType } from 'typesafe-actions'
import { IFilter } from '../../types/IFilter'
import * as actions from './actions'

export type FilterActions = ActionType<typeof actions>

export const filterReducer = (state: IFilter = {}, action: FilterActions) => {
  switch (action.type) {
    case getType(actions.updateAgeFilter):
      return {
        ...state,
        // Going through these hoops because of the React-Semantic-UI Dropdown
        age: (action.payload as string) === '' ? undefined : action.payload
      }

    case getType(actions.updateGenderFilter):
      return {
        ...state,
        gender: (action.payload as string) === '' ? undefined : action.payload
      }

    case getType(actions.updatePublicationFilter):
      return {
        ...state,
        publication:
          (action.payload as string) === '' ? undefined : action.payload
      }

    case getType(actions.updateEducationFilter):
      return {
        ...state,
        education:
          (action.payload as string) === '' ? undefined : action.payload
      }

    case getType(actions.clearFilter):
      return {}

    default:
      return state
  }
}

export type FilterState = StateType<typeof filterReducer>
